import UserAgreement from "../../user-agreement/UserAgreement";
import { Link } from "react-router-dom";
import styles from "./UserRules.module.scss";
import DownloadIcon from "../../../assets/images/user-rules/download.png";

function UserRules() {
  return (
    <>
      <div className={styles.topPart}>
        <Link
          to="https://colibri.az/uploads/static/new_terms_az.pdf"
          target="_blank"
          className={styles.link}
        >
          PDF <img src={DownloadIcon} alt="Colibri PDF Download Icon" />
        </Link>
      </div>
      <UserAgreement />
    </>
  );
}

export default UserRules;
